export default __webpack_public_path__ + "static/media/jenny.06cb107b.jpg";